import defaultItemRendererText from './default-item-renderer-text';
import SelectListItemRenderer from './select-list-item-renderer';
import type Text from './text';

/**
 * If the ItemRenderer property is not defined in the SelectList component, this component will be used as a temporary renderer until the ItemRenderer property is set.
 *
 * If the item type is a string, that string will be shown, otherwise the item will be cast to a string type and displayed.
 *
 * The same row as {@link DefaultListItemRenderer} but for the selection it carries, and a sibling of it rather than a subclass — see {@link defaultItemRendererText} for why, and for the part the two genuinely share.
 */
export default class DefaultSelectListItemRenderer<Item> extends SelectListItemRenderer<Item> {
	#text: Text;
	public constructor() {
		super();
		this.#text = defaultItemRendererText();
		this.alignment = 'left';
		this.cursor = 'pointer';
		this.height = 32;
		this.paddingHorizontal = 8;
		this.width = 'fill';
	}

	protected override initialize(): void {
		super.initialize();
		this.addComponent(this.#text);
	}

	protected override itemChanged(): void {
		super.itemChanged();
		this.#text.text = String(this.item);
	}
}
customElements.define('ac-default-select-list-item-renderer', DefaultSelectListItemRenderer);
